import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(event) {
    if (event.target.closest("a, button")) return
    Turbo.visit(this.element.dataset.href)
  }
}
